
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ConfirmDeleteProductDialog({open,  product, handleDeleteProduct, handleCancelProduct}) {
   
  return (
    <div>
     
      <Dialog
        open={open}
        onClose={handleCancelProduct}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmed</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Delete this item ? { `${product.productName}-${product.description}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleDeleteProduct} color="primary">
            Confirm
          </Button>
          <Button  variant="outlined" onClick={handleCancelProduct} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}